export const oneTypeOfAlphabetRegex = /^((([a-zA-Z]+[-\s]?)*[a-zA-Z]+)|(([а-яёА-ЯЁ]+[-\s]?)*[а-яёА-ЯЁ]+))$/;
export const oneTypeOfAlphabetEmptyRegex = /^$|^((([a-zA-Z]+[-\s]?)*[a-zA-Z]+)|(([а-яёА-ЯЁ]+[-\s]?)*[а-яёА-ЯЁ]+))$/;
export const cyrillicAlphabetRegex = /^[А-Яа-яЁё]+(?:[ -]?[А-Яа-яЁё]+)*$/;
